import React from "react";
import HeaderOne from "../components/HeaderOne";
import { Helmet } from "react-helmet-async";
import FooterAreaOne from "../components/FooterAreaOne";
import Breadcrumb from "../components/Breadcrumb";
import SubscribeOne from "../components/SubscribeOne";
import Preloader from "../helper/Preloader";
import useInitialLoad from "../helper/useInitialLoad";
import ChapaYPinturaServicesData from "../components/ChapaYPinturaServicesData";

const ChapaYPinturaServicePage = () => {
  const showPreloader = useInitialLoad(2000);

  return (
    <>
      {/* Preloader */}
      {showPreloader && <Preloader />}

      {/* Header one */}
      <HeaderOne />

      <Helmet>
        <title>Chapa y Pintura Sevilla | Reparación con Garantía de por Vida | Leal</title>
        <meta name="description" content="Reparación de chapa y pintura en Sevilla y Mairena del Aljarafe. Siniestros, abolladuras, rayones. Garantía de por vida. Presupuesto sin compromiso en 24h. Vehículo de cortesía." />
        <meta name="keywords" content="chapa pintura Sevilla, reparación siniestros Mairena, taller chapa PISA, pintura coche Sevilla, abolladura reparación, rayones pintura, taller aseguradoras Sevilla" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Chapa y Pintura Sevilla | Garantía de por Vida" />
        <meta property="og:description" content="Reparación de chapa y pintura en Sevilla. Siniestros, abolladuras, rayones. Garantía de por vida. Presupuesto sin compromiso." />
        <meta property="og:url" content="https://www.lealchapaypintura.com/chapa-y-pintura" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_ES" />
        <meta property="og:image" content="https://www.lealchapaypintura.com/favicon.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Chapa y Pintura Sevilla | Garantía de por Vida" />
        <meta name="twitter:description" content="Reparación de chapa y pintura en Sevilla. Siniestros, abolladuras, rayones. Garantía de por vida." />
        <meta name="twitter:image" content="https://www.lealchapaypintura.com/favicon.png" />
        <link rel="canonical" href="https://www.lealchapaypintura.com/chapa-y-pintura" />
      </Helmet>

      {/* Breadcrumb */}
      <Breadcrumb
        title="Chapa Y Pintura"
        parents={[{ label: "Servicios", path: "/#servicios" }]}
      />

      {/* Service Area One */}
      <ChapaYPinturaServicesData  title={"Chapa Y Pintura"} />

      {/* Subscribe One */}
      <SubscribeOne />

      {/* Footer Area One */}
      <FooterAreaOne />
    </>
  );
};

export default ChapaYPinturaServicePage;
